import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import { FaCommentAlt } from 'react-icons/fa';

const ReplyCount = ({ messageId }) => {
  const [replyCount, setReplyCount] = useState(0);

  useEffect(() => {
    const fetchReplyCount = async () => {
      try {
        const response = await axiosInstance.get(`messageboard/reply-count/${messageId}/`);
        setReplyCount(response.data.reply_count);
      } catch (error) {
        console.error('Error fetching reply count:', error);
      }
    };

    fetchReplyCount();
  }, [messageId]);

  return (
    <div className="replies-button">
      <FaCommentAlt /> {replyCount} {replyCount === 1 ? 'Reply' : 'Replies'}
    </div>
  );
};

export default ReplyCount;
